<header class="mast-main-head fixed-top">

    <!-- <div class="main-header-subscriber-offer-section">
      <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

    <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" (click)="openMarketplace()" style="cursor: pointer;">Marketplace</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" routerLink="/pricing">Pricing</a>
        </li>
        <li class="nav-item dropdown col-1-dropdown">
          <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
          <div class="dropdown-menu" style="width: 200px;">
            <ul>
              <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="Icons/Navigation/Arrow Down/Black">
                    <g id="Group">
                      <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                  </g>
                </svg> -->
              </li>
              <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
              <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
            </ul>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
        </li>
        <li class="nav-item signup-btn">
          <a class="nav-link button" href="profile.html" data-toggle="modal" routerLink="/login">Start for free</a>
        </li>
        <li class="nav-item login-btn">
        <!-- <a class="nav-link btn" href="profile.html" data-toggle="modal" routerLink="/login" data-target="#loginmodal">Login</a> -->
        </li>
      </ul>
      </div>
    </div>
    </nav>
</header>


<section class="contact-section-new" *ngIf="contactUsFields">
	<div class="container">
	<div class="row">
	<div class="col-sm-7">
		<div class="contact-widget">
			<h2 class="text-align:center;">Let's Talk!</h2>
      <p>Let's discuss your business needs & plans.</p>

      <form class="form-horizontal" [formGroup]="contactUsForm" (ngSubmit)="submitContactUs()">
        <div class="form-group">
          <div class="col_full">
            <input id="textinput" formControlName="name" maxlength="60" type="text" placeholder="Full name" class="form-control input-md" required="">
                 <span class="text-danger error-text"
                 *ngIf="(contactUsForm.controls.name.touched || submitted) && contactUsForm.controls.name.errors?.required">
                 Name is required
               </span>
          </div>
        </div>

        <div class="form-group">
          <input id="textinput" formControlName="email" type="email" maxlength="70" placeholder="abc@email.com" class="form-control input-md">
              <span class="text-danger error-text"
              *ngIf="(contactUsForm.controls.email.touched || submitted) && contactUsForm.controls.email.errors?.required">
              Email is required
            </span>
            <span class="text-danger error-text"
            *ngIf="(contactUsForm.controls.email.touched || submitted) && contactUsForm.controls.email.errors?.pattern">
            Email is not valid
          </span>
        </div>

        <!-- <div class="form-group">
            <input id="textinput" formControlName="mobile" type="number" placeholder="Mobile Number" class="form-control input-md" >
        </div> -->

        <div class="form-group">
          <textarea class="form-control workspace-text-area" style="padding: 16px 15px;" id="textarea" placeholder="Type your message here..." formControlName="message" maxlength="150"></textarea>
          <span class="text-danger error-text"
           *ngIf="(contactUsForm.controls.message.touched || submitted) && contactUsForm.controls.message.errors?.required">
           Message is required
         </span>
        </div>

        <button *ngIf="!showLoaderContact" id="singlebutton" name="singlebutton button" class="btn btn-primary">Submit</button>
        <button *ngIf="showLoaderContact" id="singlebutton" name="singlebutton button" class="btn btn-primary"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
      </form>
		</div>
	</div>
	<div class="col-sm-5 text-right"> <img src="assets/img/contact-us-graphic.svg">
	</div>
  </div>
  </div>
</section>

<!-- Search Section -->
<section class="search-section" *ngIf="thankYou">
	<div class="container">
		<div class="row">
			<div class="col-sm-12">
				<div class="inner-box">
          <img class="thnk-img" src="assets/img/confirmed.svg" alt="">
					<h1>Thank You!</h1>
          <h4>We will get back to you soon.</h4>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="faq-section-top-subscribe" style="margin-top:80px;">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h2>FAQs</h2>
          <hr>
        </div>
      </div>
    </div>
  </div>
  </section>

<section class="faq-section-subscribe">
  <div class="container">
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>How can I get in touch with your support team?</h3>
          <p>You can contact our support team by filling above form with all the required fields. Alternatively, you can send an email to <b>info@crafttor.com</b>.</p>
        </div>
      </div>
    </div>
		<hr>
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>What information should I include when reaching out to support team?</h3>
          <p>To assist you more effectively, please provide your full name, email Id and a brief description of your issue, and that would be great.</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>What can I contact support team for?</h3>
          <p>Our support team is here to assist you with product inquiries, product walk through, technical issues, account-related questions, and general support. Please don't hesitate to reach out for any concerns you may have.</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>Do you have a physical office where I can visit in person?</h3>
          <p>Currently, we do not have physical offices open to the public. We operate primarily online and provide support through digital channels.</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>How can I provide feedback or suggestions about your products or services?</h3>
          <p>We welcome your feedback and suggestions! You can share your thoughts through the "Contact Us" page or by emailing us at <b>info@crafttor.com</b>. Your input helps us improve and better serve you.</p>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>What should I do if I forgot my login credentials or password?</h3>
          <p>If you've forgotten your login information, you can use the "Forgot Password" option on the login page to reset your password. For further assistance, contact our support team.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="site-footer">
  <div class="container">
  <div class="row">
    <div class="col-sm-3">
      <div class="coulmn-1">
				<img src="assets/img/logo.svg">
				<p>Digital assets management</p>
				<a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
			</div>
    </div>
    <!-- 3 -->
    <div class="col-sm-2">
      <h5>Products</h5>
      <ul class="menu">
        <li><a routerLink="/home">Workspace</a></li>
        <li><a (click)="openMarketplace()">Marketplace</a></li>
        <li><a routerLink="/features">Features</a></li>
        <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
<li><a routerLink="/smart-storage">Smart storage</a></li>
        <li><a routerLink="/effective-search">Effective search</a></li>

      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Plugins</h5>
      <ul class="menu">
        <li><a href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
        <li><a href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
        <li><a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
        <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
        <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
        <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
        <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
<li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Solutions</h5>
      <ul class="menu">
        <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
        <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
        <li><a routerLink="/box-alternative">Box alternative</a></li>
        <li><a routerLink="/content-library">Content library</a></li>
        <li><a routerLink="/user-profiling">User Profiling</a></li>
<li><a routerLink="/approvals">Creative approvals</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Features</h5>
      <ul class="menu">
        <li><a routerLink="/features/tagging">Tagging</a></li>
        <li><a routerLink="/features/sharing">Sharing</a></li>
        <li><a routerLink="/features/versioning">Versioning</a></li>
        <li><a routerLink="/features/collaboration">Collaboration</a></li>
        <li><a routerLink="/features/integration">Integration</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Company</h5>
      <ul class="menu">
        <li><a routerLink="/about-workspace">About Workspace</a></li>
        <li><a routerLink="/contact">Contact Us</a></li>
        <li><a routerLink="/terms">Terms & Conditions</a></li>
        <li><a routerLink="/faq">FAQ</a></li>
        <li><a routerLink="/feedbacks">Feedback</a></li>
        <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
        <li><a routerLink="/our-mission">Our mission</a></li>
        <li><a routerLink="/partner-with-us">Partner with us</a></li>
      </ul>
    </div>

    <div class="col-sm-3 all-social-icons">
      <h5>Socials</h5>
				<ul class="social-icons">
					<li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
            alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
				</ul>
    </div>

    <div class="col-sm-12 text-center">
				<small>&copy; 2025 Crafttor. All rights reserved</small>
			</div>
  </div>
  </div>
</footer>
